import { useState, useEffect } from 'react';
import { ServerStatus } from '../types/server';
import { API_ENDPOINTS } from '../config/api';

export function useServerStatus(serverIp: string, interval = 60000) {
  const [serverStatus, setServerStatus] = useState<ServerStatus>({
    online: false,
    players: {
      online: 0,
      max: 0
    },
    version: ''
  });

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await fetch(`${API_ENDPOINTS.serverStatus}/${serverIp}`);
        const data = await response.json();
        
        if (response.ok) {
          setServerStatus(data);
        } else {
          console.error('Failed to fetch server status:', data.error);
          setServerStatus(prev => ({ ...prev, online: false }));
        }
      } catch (error) {
        console.error('Failed to fetch server status:', error);
        setServerStatus(prev => ({ ...prev, online: false }));
      }
    };

    // Fetch immediately
    fetchStatus();

    // Then fetch periodically
    const intervalId = setInterval(fetchStatus, interval);
    return () => clearInterval(intervalId);
  }, [serverIp, interval]);

  return serverStatus;
}